import { render, staticRenderFns } from "./CalendarClusterCard.vue?vue&type=template&id=1b49576e&scoped=true&lang=pug"
import script from "./CalendarClusterCard.vue?vue&type=script&lang=ts"
export * from "./CalendarClusterCard.vue?vue&type=script&lang=ts"
import style0 from "./CalendarClusterCard.vue?vue&type=style&index=0&id=1b49576e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b49576e",
  null
  
)

export default component.exports